var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page404"},[_c('h2',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Navigart ne peut pas s'afficher dans votre navigateur car les cookies semblent désactivés.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }